import React, { useState, useEffect } from 'react';
import { collection, query, where, orderBy, limit, getDocs, getCountFromServer } from 'firebase/firestore';
import { db } from '../../firebase';
import { useUser } from '../../hooks/UserContext';

const Card = ({ children, className }) => (
  <div className={`bg-white p-6 rounded-lg shadow-sm ${className}`}>
    {children}
  </div>
);

const formatTimestamp = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
};

const ReservedCard = () => {
  const [reservedCount, setReservedCount] = useState(0);
  const [nextBillingDate, setNextBillingDate] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useUser();

  useEffect(() => {
    const fetchReservedData = async () => {
      if (!user || !user.billwaveCustomerId) {
        return;
      }

      try {
        setLoading(true);
        const invoicesCollectionRef = collection(db, "billwaveAccounts", user.billwaveCustomerId, "scheduledInvoices");

        // 1. 予約件数を getCountFromServer で取得 (読み取りコストを大幅に削減)
        const countSnapshot = await getCountFromServer(invoicesCollectionRef);
        setReservedCount(countSnapshot.data().count);

        // 2. 次回請求日を1件だけ取得
        const nowInSeconds = Math.floor(Date.now() / 1000);
        const nextInvoiceQuery = query(
          invoicesCollectionRef,
          where("issue_at_unix", ">=", nowInSeconds),
          orderBy("issue_at_unix", "asc"),
          limit(1)
        );

        const nextInvoiceSnapshot = await getDocs(nextInvoiceQuery);
        if (!nextInvoiceSnapshot.empty) {
          const nextInvoice = nextInvoiceSnapshot.docs[0].data();
          setNextBillingDate(nextInvoice.issue_at_raw);
        } else {
          setNextBillingDate(null);
        }

        setLastUpdated(new Date());
      } catch (error) {
        console.error("Error fetching reserved data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReservedData();
  }, [user]);

  return (
    <Card className="flex flex-col justify-between h-full">
      <div>
        <div className="flex justify-between items-start">
            <h3 className="font-bold text-gray-800 mb-2">予約済み請求書</h3>
            {loading && <span className="text-xs text-gray-400">更新中...</span>}
        </div>
        <p className="text-4xl font-bold text-gray-800">
            {reservedCount} <span className="text-base font-normal">件</span>
        </p>
        
        <hr className="my-4" />
        
        <h3 className="font-bold text-gray-800 mb-2">次回請求日</h3>
        <p className="text-xl font-bold text-gray-800">{nextBillingDate || 'なし'}</p>
      </div>

      {lastUpdated && (
        <div className="text-right text-xs text-gray-400 mt-4">
          最終更新日時: {formatTimestamp(lastUpdated)}
        </div>
      )}
    </Card>
  );
};

export default ReservedCard;
